import 'select2';

(function ($) {
  'use strict';

  $(document).ready(function () {
    $('select').not(
      `
      .woocommerce .checkout .form-row select,
      .woocommerce-shipping-totals select,
      .-section-services-listing select,
      .resource-controls-filters select,
      .search-form-wrap select,
      .form-group .ql-toolbar .ql-formats select,
      .language-switcher select
      `
    ).select2({
      minimumResultsForSearch: Infinity,
    });
  });

})(jQuery);
